export enum DocumentTypeEnum {
  DOCUMENTS = "documents",
  CONTRACTS = "contracts",
  BUILDER_DOCUMENTS = "builderDocuments",
}
